import './App.css';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';
import ScrollToTop from './ScrollToTop.js';
import {useRef} from 'react';
import Badge from './assets/badge.jsx';
import InstaLogo from './InstaLogo.js';
import Title from './Title.js';
import NavigationBar from './NavigationBar.js';
import Home from './Home.js';
import Shop from './Shop.js';
import Contact from './Contact.js';
import Videos from './Videos.js';
import AnalogStage from './analogStage.js';
import AnalogStagePedal from './analogStagePedal.js';
import JfetPreamp from './JfetPreamp.js';
import PreampGuts from './assets/IMG_0321.jpg';
import analogStageGuts from './assets/IMG_0722_VSCO.JPG';
import PreampFront from './assets/IMG_0352_VSCO.jpg';
import AltoidsPreamp from './assets/IMG_0355_VSCO.jpg';
import asPedalGuts from './assets/asPedalGuts.JPG';
import AnalogStageModel from './analogStageModel.js';
import AnalogStagePedalModel from './analogStagePedalModel.js';



function App() {

    const shopRef = useRef(null);
    const videosRef = useRef(null);
    const contactRef = useRef(null);



    const today = new Date();
const year = today.getFullYear();
const month = String(today.getMonth() + 1).padStart(2, '0'); 
const day = String(today.getDate());
const formattedDate = `${month}-${day}-${year}`;
// console.log(formattedDate); 

      const products = [
          {
            id: 1,
            name: 'Analog Stage (pre-order)',
            photo: asPedalGuts,
            model: <AnalogStageModel/>,
            description: 'The Analog Stage is the ultimate finisher for your mixbus. Silky smooth highs, cleaned up low mids, and punchy and forward lows, without blowing out the rest of your mix. Featuring two NOS Telefunken ef804 tubes, known for their use in the legendary V76 and V72 mic preamps, a 12au7 driver tube, high quality cinemag input and output transformers, and some very carefully selected NOS capacitors in specific parts of the circuit. With a very minimal control panel consisting only of pre-gain, post-gain, and left and right calibration controls, dialing in a great sound is dead simple. Try it out with our virtual simulation at the bottom of this page!',
            price: '$5,000',
            route: '/analogStage'
         
        },
        {
          id: 2, 
          name: 'Analog Stage Pedal',
          photo: asPedalGuts,
          model: <AnalogStagePedalModel/>,
          description: 'The Elementary Electric Preamp is a part for part recreation of our yet to be released studio tube unit, replacing the ef804 and 12au7 tubes with j201 jfet transistors. All of the euphonic goodness from the tube circuit, in a form factor that will fit in on your pedalboard, as a desktop studio preamp, or as an insert with a reamp box.',
          price: '$299',
          route: '/AnalogStagePedal'
      },
        ]

  return (
    <div className="App">

     <Router>
      <ScrollToTop/>
     <Title/>
     <div className='navBar'>
     <NavigationBar shopRef = {shopRef} videosRef = {videosRef} contactRef = {contactRef}/>
     </div>
      <Routes>
      <Route path='/' element={<Home shopRef = {shopRef} videosRef = {videosRef} contactRef = {contactRef} products = {products}/>}></Route>
      <Route path='/analogStage' element={<AnalogStage products = {products}/>}/>
      <Route path='/analogStagePedal' element={<AnalogStagePedal products = {products}/>}/>
      </Routes>
    </Router> 


      

    </div>
  );
}

export default App;
